import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import './FooterBottom.scss';

const FooterBottom = (props) => {
  return (
    <div className="copyrights">
      <div className="container-md">
        <div className="copyrights-text roboto-regular">
          <Text field={props.fields?.CopyrightText} className="footer-link" />
        </div>
        <div className="footer-links roboto-regular">
          {props?.fields?.FooterBottomLinks?.map((footerLink, footerIndex) => (
            <React.Fragment key={footerIndex}>
              <a
                href={footerLink?.fields?.Link?.value?.href}
                target={footerLink?.fields?.Link?.value?.target}
                rel={
                  footerLink?.fields?.Link?.value?.target === '_blank'
                    ? 'noopener noreferrer'
                    : undefined
                }
                className="footer-link"
              >
                {footerLink?.fields?.Link?.value?.text}
              </a>
              {footerIndex < props.fields.FooterBottomLinks.length - 1 && (
                <span className="footer-divider footer-link">|</span>
              )}
            </React.Fragment>
          ))}
        </div>
        <div className="copyright-year roboto-regular">
          <Text field={props.fields?.YearText} className="footer-link" />
        </div>
      </div>
    </div>
  );
};

export default React.memo(FooterBottom);
